import React from 'react';

const Copyright = () => {
    return (
        <div className="copyright">
            <p>© { new Date().getFullYear() } SoftMED Synergy Marcin i Katarzyna Domańscy s.c.</p>
        </div>
    );
};

export default Copyright;
